<template>
  <div class="study">
    <div class="news_header">
      <div class="w1200 flex">
        <router-link to="/" class="header_logo"
          ><img :src="public.bottom_logo" class="block"
        /></router-link>
        <div class="header_nav f18px">
          <ul>
            <li class="header_nav_list">
              <router-link to="/" class="cl_white">首页</router-link>
            </li>
            <li class="header_nav_list">
              <router-link to="/study" class="cl_white">趣学习</router-link>
            </li>
            <li class="header_nav_list">
              <router-link to="/career" class="cl_white">生涯规划</router-link>
            </li>
            <li class="header_nav_list on">
              <router-link to="/wish" class="cl_white">志愿填报</router-link>
            </li>
            <li class="header_nav_list">
              <router-link to="/news_list" class="cl_white"
                >高中资讯</router-link
              >
            </li>
          </ul>
        </div>
        <div class="news_header_r" v-if="token == null">
          <router-link to="/" class="cl_white f16px">登录</router-link>
          &nbsp;&nbsp;&nbsp;&nbsp;<router-link
            to="/logon"
            class="cl_white f16px"
            >注册</router-link
          >
        </div>
        <div class="news_header_r" v-else>
          <router-link to="/personal" class="flex cl_white news_header_info">
            <img :src="myInfo.avatar" class="radius mar10" />
            <span
              class="f16px"
              v-if="[null, ''].indexOf(myInfo.real_name) < 0"
              >{{ myInfo.real_name }}</span
            >
            <span
              class="f16px"
              v-if="
                [null, ''].indexOf(myInfo.real_name) > 0 &&
                [null, ''].indexOf(myInfo.name) < 0
              "
              >{{ myInfo.name }}</span
            >
            <span
              class="f16px"
              v-if="
                [null, ''].indexOf(myInfo.real_name) > 0 &&
                [null, ''].indexOf(myInfo.name) > 0
              "
              >{{ myInfo.wx_nickname }}</span
            >
          </router-link>
        </div>
      </div>
    </div>
    <div class="w1200">
      <div class="major">
        <div class="flex famous_position">
          <div class="my_position_l cl_gray">
            <img src="../../../static/icon_position.png" class="mar5" />
            <p>
              当前位置：<router-link to="/" class="cl_gray">首页</router-link> >
              志愿填报
            </p>
          </div>
        </div>
      </div>
      <div class="wish_nav flex f18px cl_dark tc">
        <div
          class="wish_nav_list"
          v-for="(item, index) in wish_nav"
          :key="index"
          :class="{ on: wish_nav_cur.id == item.id }"
          @click="navCheck(index)"
        >
          <span class="cur">{{ item.name }}</span>
        </div>
      </div>
      <div class="wish_screen">
        <div class="wish_screen_top">
          <div class="wish_screen_l">
            <img
              src="../../../static/wish_01.png"
              v-if="wish_nav_cur.id == 1"
            />
            <img
              src="../../../static/wish_02.png"
              v-if="wish_nav_cur.id == 2"
            />
            <img
              src="../../../static/wish_03.png"
              v-if="wish_nav_cur.id == 3"
            />
            <img
              src="../../../static/wish_04.png"
              v-if="wish_nav_cur.id == 4"
            />
          </div>
          <div class="wish_screen_r">
            <div class="wish_screen_item">
              <div class="famous_screen_list">
                <div class="test_screen_l f18px cl_gray">
                  <span class="inline">报考年份</span><i class="inline">：</i>
                </div>
                <el-select
                  v-model="yearValue"
                  placeholder="不限"
                  @change="yearSelect"
                >
                  <el-option
                    v-for="item in year"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </div>
              <div class="famous_screen_list">
                <div class="test_screen_l f18px cl_gray">
                  <span class="inline">报考层次</span><i class="inline">：</i>
                </div>
                <el-select
                  v-model="levelValue"
                  placeholder="不限"
                  @change="levelSelect"
                >
                  <el-option
                    v-for="item in level"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="wish_screen_item mat30">
              <div class="famous_screen_list">
                <div class="test_screen_l f18px cl_gray">
                  <span class="inline">报考批次</span><i class="inline">：</i>
                </div>
                <el-select
                  v-model="batchValue"
                  clearable
                  placeholder="不限"
                  @change="batchSelect"
                >
                  <el-option
                    v-for="item in batch"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </div>
              <div class="famous_screen_list">
                <div class="test_screen_l f18px cl_gray">
                  <span class="inline">文理科</span><i class="inline">：</i>
                </div>
                <el-select v-model="scienceValue" placeholder="不限">
                  <el-option
                    v-for="item in science"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="wish_screen_item mat15" v-if="wish_nav_cur.id == 2">
              <div class="famous_screen_list">
                <div class="test_screen_l f18px cl_gray"></div>
                <div class="f16px cl_gray flex">
                  <label class="mar15 cur flex"
                    ><input
                      type="radio"
                      value="single"
                      v-model="rank_area"
                    /><span class="mal5">按位次查询</span></label
                  >
                  <label class="mal15 cur flex"
                    ><input
                      type="radio"
                      value="double"
                      v-model="rank_area"
                    /><span class="mal5">按位次段查询</span></label
                  >
                </div>
              </div>
            </div>
            <div
              class="wish_screen_item mat30"
              v-if="
                wish_nav_cur.id == 1 ||
                (wish_nav_cur.id == 2 && rank_area == 'single')
              "
            >
              <div class="test_screen_l f18px cl_gray">
                <span class="inline">位次</span><i class="inline">：</i>
              </div>
              <input
                type="text"
                placeholder="请输入您的位次"
                @input="rankInput"
                v-model="rank_input"
                class="wish_screen_input f16px radius20"
              />
              <button
                class="f16px cl_white radius20 bg_white wish_screen_btn"
                @click="query"
              >
                查询
              </button>
            </div>
            <div
              class="wish_screen_item mat30 wish_screen_item_area"
              v-if="wish_nav_cur.id == 2 && rank_area == 'double'"
            >
              <div class="test_screen_l f18px cl_gray">
                <span class="inline">位次段</span><i class="inline">：</i>
              </div>
              <input
                type="text"
                placeholder="请输入起始位次"
                @input="rankStart"
                v-model="rank_start"
                class="wish_screen_input f16px radius20"
              />
              <p class="cl_gray">———</p>
              <input
                type="text"
                placeholder="请输入截止位次"
                @input="rankEnd"
                v-model="rank_end"
                class="wish_screen_input f16px radius20"
              />
              <button
                class="f16px cl_white radius20 bg_white wish_screen_btn"
                @click="query"
              >
                查询
              </button>
            </div>
            <div class="wish_screen_item mat30" v-if="wish_nav_cur.id == 3">
              <div class="test_screen_l f18px cl_gray">
                <span class="inline">专业</span><i class="inline">：</i>
              </div>
              <input
                type="text"
                placeholder="请输入专业名称"
                v-model="major_input"
                class="wish_screen_input f16px radius20"
              />
              <button
                class="f16px cl_white radius20 bg_white wish_screen_btn"
                @click="query"
              >
                查询
              </button>
            </div>
            <div class="wish_screen_item mat30" v-if="wish_nav_cur.id == 4">
              <div class="test_screen_l f18px cl_gray">
                <span class="inline">院校</span><i class="inline">：</i>
              </div>
              <input
                type="text"
                placeholder="请输入院校名称"
                v-model="uni_input"
                class="wish_screen_input f16px radius20"
              />
              <button
                class="f16px cl_white radius20 bg_white wish_screen_btn"
                @click="query"
              >
                查询
              </button>
            </div>
          </div>
        </div>
        <div class="wish_screen_btm mat10" v-if="uni_open">
          <div class="famous_screen_list">
            <span class="cl_gray f18px">院校属地：</span>
            <el-select
              v-model="provinceValue"
              placeholder="院校属地"
              @change="provinceSelect"
            >
              <el-option
                v-for="item in province"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="popup_cont_btm mat10" v-if="university_list.length > 0">
            <span
              class="popup_un bg_gray"
              v-for="(item, index) in university_list"
              :key="index"
              @click="selectMajor(item.name)"
              >{{ item.name }}</span
            >
          </div>
          <div class="tc mat30 18px cl_gray" v-else>
            该省份暂时没有院校，请从新选择
          </div>
        </div>
        <div
          class="wish_screen_fixed tc cl_violet cur"
          v-if="wish_nav_cur.id == 4"
          :class="{ open: uni_open }"
          @click="uniOpen"
        >
          <p>{{ uni_open == true ? "收起" : "按省份浏览院校" }}</p>
          <img src="../../../static/select_violet.png" class="bg_white" />
        </div>
      </div>
      <div class="wish mat50" v-if="list_show">
        <div class="mab20 f16px" v-if="wish_nav_cur.id == 1">
          在<span class="cl_red">{{ myInfo.province_name }}</span
          >查询<span class="cl_red">{{ yearValue }}</span
          >年， <span class="cl_red">{{ levelValue }}</span
          >，<span class="cl_red">{{ scienceValue }}</span
          >，<span class="cl_red">{{
            batchValue == "" ? "不限批次" : batchValue
          }}</span
          >， 院校投档分位次<span class="cl_red">{{ rank_input }}</span
          >附近及以下录取结果如下:
        </div>

        <div class="mab20 f16px" v-if="wish_nav_cur.id == 2">
          在<span class="cl_red">{{ myInfo.province_name }}</span
          >查询<span class="cl_red">{{ yearValue }}</span
          >年， <span class="cl_red">{{ levelValue }}</span
          >，<span class="cl_red">{{ scienceValue }}</span
          >，<span class="cl_red">{{
            batchValue == "" ? "不限批次" : batchValue
          }}</span
          >， 录取位次<span class="cl_red" v-if="rank_area == 'single'">{{
            rank_input
          }}</span>
          <span v-if="rank_area == 'double'"
            ><span class="cl_red">{{ rank_start }}</span
            >-<span class="cl_red">{{ rank_end }}</span></span
          ><i v-if="rank_area == 'single'">附近及以下</i>录取结果如下:
        </div>

        <div class="mab20 f16px" v-if="wish_nav_cur.id == 3">
          在<span class="cl_red">{{ myInfo.province_name }}</span
          >查询<span class="cl_red">{{ yearValue }}</span
          >年， <span class="cl_red">{{ levelValue }}</span
          >，<span class="cl_red">{{ scienceValue }}</span
          >，<span class="cl_red">{{
            batchValue == "" ? "不限批次" : batchValue
          }}</span
          >， <span class="cl_red">{{ major_input }}</span
          >录取结果如下:
        </div>

        <div class="mab20 f16px" v-if="wish_nav_cur.id == 4">
          在<span class="cl_red">{{ myInfo.province_name }}</span
          >查询<span class="cl_red">{{ yearValue }}</span
          >年， <span class="cl_red">{{ levelValue }}</span
          >，<span class="cl_red">{{ scienceValue }}</span
          >，<span class="cl_red">{{
            batchValue == "" ? "不限批次" : batchValue
          }}</span
          >， <span class="cl_red">{{ uni_input }}</span
          >录取结果如下:
        </div>

        <div class="choice_select" v-if="wish_nav_cur.id != 4">
          <div class="famous_screen_list">
            <span class="cl_gray f18px">个人偏好：</span>
            <el-select
              v-model="sdValue"
              clearable
              placeholder="按院校所在地筛选"
              @change="sdSelect"
            >
              <el-option
                v-for="item in sd"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div
            class="famous_screen_list"
            v-if="wish_nav_cur.id == 1 || wish_nav_cur.id == 4"
          >
            <el-select
              v-model="typeValue"
              clearable
              placeholder="按院校类型"
              @change="typeSelect"
            >
              <el-option
                v-for="item in type"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="wish_cont">
          <table class="choice_table">
            <thead>
              <tr class="f18px">
                <th width="300px" :class="{ on: wish_nav_cur.id == 4 }">
                  院校名称
                </th>
                <th width="200px">院校投档分</th>
                <th width="200px" :class="{ on: wish_nav_cur.id == 1 }">
                  院校投档分位次
                </th>
                <th
                  width="200px"
                  v-if="wish_nav_cur.id == 1 || wish_nav_cur.id == 4"
                >
                  文/理科
                </th>
                <th
                  width="200px"
                  v-if="wish_nav_cur.id == 2 || wish_nav_cur.id == 3"
                  :class="{ on: wish_nav_cur.id == 3 }"
                >
                  专业名称
                </th>
                <th
                  width="200px"
                  v-if="wish_nav_cur.id == 2 || wish_nav_cur.id == 3"
                >
                  专业录取最低分
                </th>
                <th
                  width="200px"
                  v-if="wish_nav_cur.id == 2 || wish_nav_cur.id == 3"
                  :class="{ on: wish_nav_cur.id == 2 }"
                >
                  专业最低分位次
                </th>
                <th width="200px">本专科批次</th>
                <th width="200px">专业录取信息</th>
              </tr>
            </thead>
            <tbody class="f16px cl_dark">
              <tr v-for="(item, index) in list" :key="index">
                <td :class="{ on: wish_nav_cur.id == 4 }">
                  <router-link
                    :to="{
                      path: '/treasury_details',
                      query: { id: item.id, type: 4 },
                    }"
                    class="f18px cl_black"
                    >{{ item.university_name }}</router-link
                  >
                  <div
                    class="choice_table_tip f12px tc mat20"
                    v-if="item.featureList.length > 0 || item.city_name != null"
                  >
                    <div
                      class="choice_table_item cl_white"
                      v-for="(item, index) in item.featureList"
                      :key="index"
                      :class="[
                        { first: item == '985工程' },
                        { second: item == '211工程' },
                      ]"
                    >
                      {{ item }}
                    </div>
                    <div
                      class="choice_table_item choice_table_item_last cl_violet"
                      v-if="item.city_name != null"
                    >
                      {{ item.province_name }}
                    </div>
                  </div>
                </td>
                <td align="center">
                  <p>{{ item.school_min }}</p>
                </td>
                <td align="center" :class="{ on: wish_nav_cur.id == 1 }">
                  <p>{{ item.school_rank }}</p>
                </td>
                <td
                  align="center"
                  v-if="wish_nav_cur.id == 1 || wish_nav_cur.id == 4"
                >
                  <p>{{ item.exam_type }}</p>
                </td>
                <td
                  align="center"
                  v-if="wish_nav_cur.id == 2 || wish_nav_cur.id == 3"
                  :class="{ on: wish_nav_cur.id == 3 }"
                >
                  <p>{{ item.major_name }}</p>
                </td>
                <td
                  align="center"
                  v-if="wish_nav_cur.id == 2 || wish_nav_cur.id == 3"
                >
                  <p>{{ item.min }}</p>
                </td>
                <td
                  align="center"
                  v-if="wish_nav_cur.id == 2 || wish_nav_cur.id == 3"
                  :class="{ on: wish_nav_cur.id == 2 }"
                >
                  <p>{{ item.major_rank }}</p>
                </td>
                <td align="center">
                  <p>{{ item.level }}</p>
                </td>
                <td align="center">
                  <router-link
                    :to="{
                      path: '/wish_list',
                      query: {
                        id: item.id,
                        name: item.university_name,
                        year: yearValue,
                        level: item.level,
                        science: scienceValue,
                      },
                    }"
                    class="cl_blue"
                    >查看</router-link
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="famous_page flex" v-if="list.length > 0">
          <div class="famous_page_l f16px cl_gray">
            共 {{ total }} 条记录 页次：{{ currentPage }}/{{
              Math.ceil(total / pageSize)
            }}页 {{ pageSize }}条/页
          </div>
          <div class="famous_page_r cl_dark">
            <el-pagination
              background
              layout="prev, pager, next, jumper"
              @current-change="handleCurrentChange"
              :page-size="pageSize"
              :current-page="currentPage"
              :total="total"
            ></el-pagination>
          </div>
        </div>
        <div class="choice_empty tc f18px cl_gray" v-if="list.length == 0">
          <p>找不到内容，请重新选择。</p>
        </div>
      </div>
      <div class="wish_tip radius8">
        <div class="wish_tip_title">
          <img src="../../../static/wish_tip.png" />
          <span class="f20px bold mal10">数据说明</span>
        </div>
        <div class="wish_tip_cont f16px cl_dark mat10" v-html="wish_tip"></div>
      </div>
    </div>
    <vfooter @child-event="publicEvent"></vfooter>
  </div>
</template>

<script>
import vfooter from "../../components/footer.vue";
export default {
  name: "wish",
  components: {
    vfooter,
  },
  props: {},
  data() {
    return {
      token: localStorage.getItem("token"),
      myInfo: {}, //个人信息
      public: {}, //公共部分
      wish_nav: [
        {
          id: 1,
          name: "按院校投档分位次查询",
        },
        {
          id: 2,
          name: "按专业最低分位次查询",
        },
        {
          id: 3,
          name: "按专业名称查询",
        },
        {
          id: 4,
          name: "按院校名称查询",
        },
      ],
      wish_nav_cur: {
        id: 1,
        name: "按院校投档分位次查询",
      },
      wish_tip:
        "<p>1、系统不包含提前批数据，报考提前批考生请参考省招办或学校官网公布的信息，结合政策和自身条件进行填报。</p>" +
        "<p>2、我们的数据与各省教育考试院发布的数据一致，由于各省市加分政策、学校官网对征集志愿数据的显示等原因，会与院校官网存在不一致情况，建议以各省考试院发布的数据为准。</p>" +
        "<p>3、部分专业包括但不仅限于中外合作、校企合作、联合办学、定向、预科、农林、护理、软件工程等等特殊类型，分数相较普通类招生普遍偏低，故这部分专业的录取分数低于该院校投档线属于正常现象，望知悉。</p>" +
        "<p>4、各省招生计划的更新时间在出分后，未更新前可以去学校官网查询，或翻阅学校下发的招生计划书，但最终请以省招办发行的招生计划书为准，望悉知！</p>" +
        "<p>5、本系统提供的所有数据仅供考生填报志愿时参考使用，考生应考虑到高校招生计划的变化、高考试题的难度变化以及其它偶然因素引起的偏差，所提供的信息不作为填报志愿的绝对依据。</p>",
      level: [], //层次
      levelValue: "",
      year: [], //年份
      yearValue: "",
      batch: [], //批次
      batchValue: "",
      sdValue: "", //院校属地
      sd: [],
      typeValue: "", //院校类型
      type: [],
      science: ["理科", "文科", "不分文理"],
      scienceValue: "理科",
      rank_input: "", //位次
      rank_area: "single",
      rank_start: 0,
      rank_end: 0,
      major_input: "",
      uni_input: "",
      uni_open: false, //院校展开
      province: [],
      provinceValue: "",
      university_list: [],
      list: [],
      list_show: false,
      currentPage: 1, //当前页数
      pageSize: 15, //每页数量
      total: 0, //总页数
    };
  },
  mounted() {
    this.getMyinfo();
    this.getLevel();
    this.getDate();
    this.getBatch();
    this.getSd();
    this.getType();
  },
  created() {},
  methods: {
    publicEvent(data) {
      this.public = data;
    },
    //获取用户信息
    getMyinfo() {
      var that = this;
      that
        .$get("/api/user/get_user_info", {
          token: localStorage.getItem("token"),
        })
        .then((res) => {
          that.myInfo = res.data;
        });
    },
    //院校层次
    getLevel() {
      this.$get("/api/careerbible/get_level_data", {}).then((res) => {
        this.level = res.data;
        this.levelValue = this.level[0];
      });
    },
    //年份
    getDate() {
      this.$get("/api/tocollege/get_tocollege_year_data", {
        token: localStorage.getItem("token"),
      }).then((res) => {
        this.year = res.data;
        this.yearValue = this.year[0];
      });
    },
    //批次
    getBatch() {
      this.$get("/api/tocollege/get_tocollege_level_data", {
        token: localStorage.getItem("token"),
      }).then((res) => {
        this.batch = res.data;
      });
    },
    //院校属地
    getSd() {
      this.$get("/api/careerbible/get_province_data", {}).then((res) => {
        this.sd = res.data;
        this.province = this.province.concat(res.data);
        this.provinceValue = this.province[0].id;
        this.getUn();
      });
    },
    //院校类型
    getType() {
      this.$get("/api/careerbible/get_type_data", {}).then((res) => {
        this.type = res.data;
      });
    },
    getList() {
      var rank = "";
      rank = this.rank_input;
      this.list_show = true;
      this.$get("/api/tocollege/get_tocollege_school_list", {
        token: localStorage.getItem("token"),
        page: this.currentPage,
        limit: this.pageSize,
        year: this.yearValue,
        gradation: this.levelValue,
        level: this.batchValue,
        rank: rank,
        province_id: this.sdValue,
        type: this.typeValue,
        name: this.uni_input,
        exam_type: this.scienceValue,
      }).then((res) => {
        this.total = res.data.total;
        this.list = [];
        this.list = res.data.data;
        for (let i = 0; i < this.list.length; i++) {
          this.list[i].featureList = [];
          if (this.list[i].feature != "" && this.list[i].feature != null) {
            this.list[i].featureList = this.list[i].feature.split(",");
          }
        }
      });
    },
    getMajor() {
      var rank = "";
      if (this.wish_nav_cur.id == 2 && this.rank_area == "double") {
        if (this.rank_start > this.rank_end) {
          this.$message({
            type: "warning",
            message: "起始位次不能大于截止位次",
            duration: 1500,
          });
          return false;
        }
        rank = this.rank_start + "," + this.rank_end;
      }
      if (this.wish_nav_cur.id == 2 && this.rank_area == "single") {
        rank = this.rank_input;
      }
      this.list_show = true;
      this.$get("/api/tocollege/get_tocollege_major_list", {
        token: localStorage.getItem("token"),
        page: this.currentPage,
        limit: this.pageSize,
        year: this.yearValue,
        gradation: this.levelValue,
        level: this.batchValue,
        rank: rank,
        province_id: this.sdValue,
        type: this.typeValue,
        name: this.major_input,
        exam_type: this.scienceValue,
      }).then((res) => {
        this.total = res.data.total;
        this.list = [];
        this.list = res.data.data;
        for (let i = 0; i < this.list.length; i++) {
          this.list[i].featureList = [];
          if (this.list[i].feature != "" && this.list[i].feature != null) {
            this.list[i].featureList = this.list[i].feature.split(",");
          }
        }
      });
    },
    //导航切换
    navCheck(e) {
      this.wish_nav_cur = this.wish_nav[e];
      this.list = [];
      this.rank_input = "";
      this.rank_start = "";
      this.rank_end = "";
      this.major_input = "";
      this.uni_input = "";
      this.sdValue = "";
      this.typeValue = "";
      this.list_show = false;
    },
    yearSelect(e) {},
    levelSelect(e) {},
    batchSelect(e) {},
    sdSelect(e) {
      this.currentPage = 1;
      if (this.wish_nav_cur.id == 1 || this.wish_nav_cur.id == 4) {
        this.getList();
      } else {
        this.getMajor();
      }
    },
    typeSelect(e) {
      this.currentPage = 1;
      if (this.wish_nav_cur.id == 1 || this.wish_nav_cur.id == 4) {
        this.getList();
      } else {
        this.getMajor();
      }
    },
    rankInput(e) {
      this.rank_input = this.rank_input.replace(/[^0-9]/g, "");
    },
    rankStart(e) {
      this.rank_start = this.rank_start.replace(/[^0-9]/g, "");
    },
    rankEnd(e) {
      this.rank_end = this.rank_end.replace(/[^0-9]/g, "");
    },
    //获取学校列表
    getUn() {
      this.$get("/api/selectsubject/get_university_show_data", {
        province_id: this.provinceValue,
      }).then((res) => {
        this.university_list = res.data;
      });
    },
    provinceSelect(e) {
      this.getUn();
    },
    selectMajor(e) {
      this.uni_open = false;
      this.uni_input = e;
      this.getList();
    },
    //查询
    query() {
      if (this.wish_nav_cur.id == 1) {
        if (this.rank_input == "") {
          this.$message({
            duration: 1500,
            message: "位次不能为空",
            type: "warning",
          });
          return false;
        }
        this.currentPage = 1;
        this.getList();
      } else if (this.wish_nav_cur.id == 2) {
        this.currentPage = 1;
        this.getMajor();
      } else if (this.wish_nav_cur.id == 3) {
        if (this.major_input == "") {
          this.$message({
            duration: 1500,
            message: "专业名称不能为空",
            type: "warning",
          });
          return false;
        }
        this.currentPage = 1;
        this.getMajor();
      } else {
        if (this.uni_input == "") {
          this.$message({
            duration: 1500,
            message: "院校名称不能为空",
            type: "warning",
          });
          return false;
        }
        this.currentPage = 1;
        this.getList();
      }
    },
    uniOpen() {
      if (this.uni_open == true) {
        this.uni_open = false;
      } else {
        this.uni_open = true;
      }
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      if (this.wish_nav_cur.id == 1 || this.wish_nav_cur.id == 4) {
        this.getList();
      } else {
        this.getMajor();
      }
    },
  },
};
</script>

<style>
</style>
